/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DiaryMetricView = null | null | null | null;

export const DiaryMetricView = {
    NUMBER_null: null as DiaryMetricView,
    NUMBER_null2: null as DiaryMetricView,
    NUMBER_null3: null as DiaryMetricView,
    NUMBER_null4: null as DiaryMetricView
};

